<template>
  <section>
    <div class="table-responsive">
      <table class="table p-0 m-0 dataTable text-nowrap min-h-[150px]">
        <thead class="bg-white">
          <tr class="py-[5px]">
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Created
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Order Date
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Channel
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Customer
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Total
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Created By
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Request Status
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Action
            </th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr v-if="isLoading">
            <td colspan="12" class="text-center">
              <div
                class="text-center"
                style="padding-top: 100px; padding-bottom: 50px"
              >
                <span
                  class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                  style="font-size: 8rem"
                ></span>
                <h3
                  class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                  style="padding-bottom: 100px"
                >
                  Please wait while we load the list
                </h3>
              </div>
            </td>
          </tr>
          <tr v-for="o in cancelledOrders" :key="o.id" v-else>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              {{ formatDate(o.orderDate) }}
            </td>
            <td class="text-[#2463EB] font-medium text-[14px] leading-[20px]">
              {{ o.orderNumber }}
            </td>
            <td
              class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
            >
              {{ o.source }}
            </td>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              {{ o.maker.displayName }}
            </td>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              &#8358; {{ formatMoney(o.total) }}
            </td>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              {{ o.orderCreatedBy ? o.orderCreatedBy.displayName : "N/A" }}
            </td>
            <td>
              <button
                :class="[
                  'badge',

                  {
                    'badge-warning': o.status == 'Pending',
                  },
                  {
                    'badge-success':
                      o.status == 'Confirmed' || 'markAsDelivered',
                  },
                  {
                    'badge-info': o.status == 'Dispatched',
                  },

                  {
                    'badge-primary': o.status == 'recallDelivery',
                  },
                ]"
              >
                <span
                  class="inline-block w-[10px] h-[10px] rounded-[1px]"
                  :style="{
                    backgroundColor:
                      o.status === 'Pending'
                        ? '#FFA500'
                        : o.status === 'Confirmed' || 'markAsDelivered'
                        ? '#16a249'
                        : o.status === 'Dispatched'
                        ? '#17A2B8'
                        : o.status === 'recallDelivery'
                        ? '#007BFF'
                        : '#E42728',
                  }"
                ></span>

                {{ o.status }}
              </button>
            </td>
            <td>
              <div class="dropdown">
                <button
                  class="btn-no-border"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span
                    class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                  >
                    ...
                  </span>
                </button>

                <ul
                  class="dropdown-menu"
                  v-if="
                    o.cancellationStatus == 'request' ||
                      o.cancellationStatus == 'rejected'
                  "
                >
                  <li
                    v-if="
                      o.cancellationStatus == 'request' ||
                        o.cancellationStatus == 'rejected'
                    "
                    class="text-[14px] font-normal leading-[20px] text-[#353535] border-b cursor-pointer py-[8px] px-[16px] flex gap-[4px] items-center"
                    @click.prevent="
                      viewCancellationReason(
                        o.cancellationReason,
                        o.distributorCancellationReason
                      )
                    "
                  >
                    <img src="/assets/icon/eye.svg" />
                    View Reason
                  </li>

                  <li
                    v-if="
                      hasPermission('Orders_Accept_Cancellation') &&
                        o.status == 'Cancelling'
                    "
                    @click.prevent="cancelRequest(o.id, 'accepted')"
                    class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b py-[8px] px-[16px] flex gap-[4px] items-center"
                  >
                    <img src="/assets/icon/tick-circle.svg" />
                    Accept Cancel
                  </li>
                  <li
                    v-if="
                      hasPermission('Orders_Reject_Cancellation') &&
                        o.status == 'Cancelling'
                    "
                    href="#"
                    @click.prevent="viewCancelOrder(o.id)"
                    class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[8px] px-[16px] flex gap-[4px] items-center"
                  >
                    <img src="/assets/icon/close-circle.svg" />
                    Reject Cancel
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr v-if="!cancelledOrders.length && !isLoading">
            <td colspan="10">
              <div class="text-center" style="padding-top: 50px">
                <span style="font-size: 4.615rem" class="mdi mdi-basket"></span>
              </div>
              <h3 class="text-center" style="padding-bottom: 100px">
                You have not recieved any orders.
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination
        :limit="cancelPageSize"
        :count="cancelPageCount"
        :page="cancelPage"
        :itemsCount="cancelCount"
        @changePage="cancelGotoPage"
        @changeLimit="cancelChangeLimit"
      />
    </div>
  </section>
</template>

<script>
import moment from "moment";
import { helper } from "@/helper";
import Pagination from "../Pagination.vue";
export default {
  components: {
    Pagination,
  },
  props: [
    "cancelledOrders",
    "isLoading",
    "hasPermission",
    "viewCancellationReason",
    "viewCancelOrder",
    "cancelRequest",
    "cancelCount",
    "cancelGotoPage",
    "cancelChangeLimit",
    "changeLimit",
    "cancelPageCount",
    "cancelPageSize",
    "cancelPage",
  ],

  methods: {
    formatDate(date) {
      return moment(date).format("ll");
    },

    formatDateWithTime(date) {
      return moment(date).format("lll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
  },
};
</script>

<style></style>
